import React from "react";
import ServiceDetailLayout from "./ServiceDetailLayout";

export default function EcommerceDetail() {
	return (
		<ServiceDetailLayout
			title="E-commerce & Marketplace"
			summarySections={[
				{ id: "intro", label: "Introduction" },
				{ id: "pourquoi", label: "Pourquoi l’e-commerce ?" },
				{ id: "avantages", label: "Bénéfices pour votre activité" },
				{ id: "solutions", label: "Solutions proposées" },
				{ id: "securite", label: "Sécurité & conformité" },
				{ id: "accompagnement", label: "Accompagnement & support" },
				{ id: "process", label: "Notre Processus" },
				{ id: "faq", label: "FAQ" }
			]}
		>
			<section id="intro">
				<h2>Introduction</h2>
				<p>
					Nous accompagnons les commerçants, marques et porteurs de projets dans la création, la refonte et l’optimisation de plateformes e-commerce et marketplaces. Notre expertise couvre la conception UX/UI, le développement sur-mesure, l’intégration de solutions de paiement et la gestion de catalogues complexes, avec un focus sur la performance, la sécurité et la conversion.
				</p>
			</section>
			<section id="pourquoi">
				<h2>Pourquoi l’e-commerce&nbsp;?</h2>
				<p>
					L’e-commerce est un levier de croissance incontournable pour toucher de nouveaux clients, diversifier ses canaux de vente et automatiser la gestion des commandes. Une plateforme performante permet d’augmenter le chiffre d’affaires, de fidéliser la clientèle et de s’adapter rapidement aux évolutions du marché.
				</p>
			</section>
			<section id="avantages">
				<h2>Bénéfices pour votre activité</h2>
				<p>
					• Augmentation du chiffre d’affaires et de la rentabilité<br />
					• Automatisation des ventes et gestion simplifiée des stocks<br />
					• Personnalisation de l’expérience client et marketing ciblé<br />
					• Ouverture vers de nouveaux marchés et partenaires<br />
					• Sécurisation des transactions et conformité réglementaire
				</p>
			</section>
			<section id="solutions">
				<h2>Solutions proposées</h2>
				<p>
					Nous réalisons des projets e-commerce sur-mesure :<br />
					• Création de boutiques en ligne, marketplaces et plateformes B2B/B2C<br />
					• Intégration de solutions de paiement, logistique et CRM<br />
					• Développement de modules spécifiques (abonnement, click & collect, gestion multi-boutiques)<br />
					• Optimisation SEO, performance et conversion<br />
					• Monitoring, reporting et analyse des ventes<br />
					Chaque solution est adaptée à votre secteur d’activité et à vos objectifs de croissance.
				</p>
			</section>
			<section id="securite">
				<h2>Sécurité & conformité</h2>
				<p>
					Nous appliquons les meilleures pratiques en matière de sécurité des transactions (chiffrement, authentification forte, gestion des droits, audits réguliers) et garantissons la conformité RGPD et sectorielle de vos plateformes.
				</p>
			</section>
			<section id="accompagnement">
				<h2>Accompagnement & support</h2>
				<p>
					Un chef de projet dédié vous accompagne dans la définition de votre stratégie e-commerce, la rédaction du cahier des charges et la formation de vos équipes. Notre support technique est disponible en continu, avec des engagements de service (SLA) adaptés à vos enjeux critiques et une assistance personnalisée pour chaque incident ou évolution.
				</p>
			</section>
			<section id="process">
				<h2>Notre Processus</h2>
				<ol>
					<li>Audit de l’existant et définition des besoins</li>
					<li>Conception UX/UI et choix des solutions</li>
					<li>Développement, tests et validation métier</li>
					<li>Déploiement, monitoring et optimisation continue</li>
					<li>Formation, documentation et transfert de compétences</li>
				</ol>
			</section>
			<section id="faq">
				<h2>FAQ</h2>
				<p>
					Besoin d’un conseil sur la création, la refonte ou l’optimisation de votre site e-commerce&nbsp;? Nos consultants sont à votre écoute pour vous apporter des réponses concrètes et des solutions adaptées à votre secteur d’activité.
				</p>
			</section>
		</ServiceDetailLayout>
	);
}
